import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";

import "./basealert.scss";


const BaseAlert = ({
    message,
    severity = "success",
    "data-test": dataTest = "status-alert",
}) => (
    <Alert
        className="baseAlert"
        severity={severity}
        variant="standard"
        data-test={dataTest}
    >
        {message}
    </Alert>
);

BaseAlert.propTypes = {
    message: PropTypes.string.isRequired,
    severity: PropTypes.oneOf(["success", "info", "warning", "error"]),
    "data-test": PropTypes.string,
};

export default BaseAlert;
